// extracted by mini-css-extract-plugin
export default {"root":"root--f__bI","scroll":"scroll--tyu1H","disableScroll":"disableScroll--PnsMg"};